import React from 'react';

interface CenteredFormProps {
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent) => void;
  className?: string;
}

const CenteredForm: React.FC<CenteredFormProps> = ({
  children,
  onSubmit,
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-lg p-8 ${className}`}>
      <form className="space-y-6" onSubmit={onSubmit}>
        {children}
      </form>
    </div>
  );
};

export default CenteredForm;
